import 'show-index/styles/index.less';
import ShowsStore from 'show-index/stores/shows';
import ShowIndex from 'show-index/containers/main';
import { cloneDeep } from 'lodash';
import { Provider } from 'mobx-react';
import { render } from 'react-dom';


const INITIAL_DATA = cloneDeep(window.__AS_INITIAL_DATA__);
const SHOWS_STORE = new ShowsStore(INITIAL_DATA);


if (process.env.NODE_ENV === 'development') {
    window.ShowsStore = SHOWS_STORE;
    window.toJS = require('mobx').toJS;
}


render(
    <Provider showsStore={ SHOWS_STORE }>
        <ShowIndex />
    </Provider>,
    document.getElementById('show-index-page')
);



// WEBPACK FOOTER //
// ./src/show-index/index.js